{
  "messages": {
    "rescheduledOnce": "Rescheduled once",
    "rescheduledTwice": "Rescheduled twice",
    "rescheduledCountTimes": "Rescheduled {count} times"
  }
}
